import shopOfTheYearWinners from './shop-of-the-year-winners';
import shopOfTheYearLeaderboard from './shop-of-the-year-leaderboard';

export default (props, context) => {
  if (!props.data) {
    return {};
  }

  if (props.data.shopOfTheYear && props.data.shopOfTheYear.isVotingOpen) {
    return shopOfTheYearLeaderboard(props, context);
  }

  return shopOfTheYearWinners(props, context);
};
